import {
  CheckoutSessionResponse,
  UserPaidSubscription,
} from "@/data/v2/models/subscriptions";
import { SubscriptionEvents, trackEvent } from "@/analytics";
import { getApiClient } from "@punchup/utils/apiRegistry";

export async function createCheckoutSession(
  comedianId: string,
  tier: string,
  incomplete_transaction_id?: string,
  returnUrl?: string,
  attribution?: Record<string, string>
): Promise<CheckoutSessionResponse> {
  const { data } = await getApiClient().post<{
    data: CheckoutSessionResponse;
  }>("/api/v2/user/paid-subscriptions/checkout-session", {
    comedian_id: comedianId,
    tier,
    return_url: returnUrl,
    incomplete_transaction_id,
    attribution,
  });
  return data;
}

export async function getUserPaidSubscriptions(params?: {
  active?: boolean;
  comedianId?: string;
}): Promise<UserPaidSubscription[]> {
  const searchParams = new URLSearchParams();
  if (params?.active !== undefined) {
    searchParams.append("active", params.active.toString());
  }
  if (params?.comedianId) {
    searchParams.append("comedian_id", params.comedianId);
  }

  const queryString = searchParams.toString();
  const url = `/api/v2/user/paid-subscriptions${queryString ? `?${queryString}` : ""}`;

  const { data } = await getApiClient().get<{ data: UserPaidSubscription[] }>(
    url
  );
  return data ?? [];
}

export async function upgradePaidSubscriptionTier(
  comedianId: string,
  newTier: string
): Promise<void> {
  await getApiClient().post("/api/v2/user/paid-subscriptions/upgrade-tier", {
    comedian_id: comedianId,
    new_tier: newTier,
  });
  trackEvent(SubscriptionEvents.UPGRADE_TIER, {
    comedian_id: comedianId,
    new_tier: newTier,
  });
}

export async function downgradePaidSubscriptionTier(
  comedianId: string,
  newTier: string
): Promise<void> {
  await getApiClient().post("/api/v2/user/paid-subscriptions/downgrade-tier", {
    comedian_id: comedianId,
    new_tier: newTier,
  });
  trackEvent(SubscriptionEvents.DOWNGRADE_TIER, {
    comedian_id: comedianId,
    new_tier: newTier,
  });
}

export async function hasPaidSubscription(
  comedianId: string
): Promise<boolean> {
  const subscriptions = await getUserPaidSubscriptions({
    active: true,
    comedianId,
  });
  return subscriptions.length > 0;
}
